import React = require('react');
import { ButtonType,ButtonWidget } from '@tableau/widgets';
import { FormikProps, FormikValues } from 'formik';

import { Messages } from '../../codegen/Localize';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';

export interface UserSettingEditButtonsProps {
  handleClick?: () => void;
  handleSubmit?: () => void;
  testId: string;
  formik: FormikProps<FormikValues>;
  disabled?: boolean;
}

export function InlineCancelAndSaveButtons(props: UserSettingEditButtonsProps) {
  return (
    <tr>
      <td className={UserSettingsStyle.labelText}></td>
      <td className={UserSettingsStyle.buttons}>
        <span className={UserSettingsStyle.cancelButton}>
          <ButtonWidget
            type="reset"
            buttonType={ButtonType.Outline}
            onClick={() => props.handleClick ? props.handleClick() : props.formik.resetForm()}
            testId={props.testId + '-cancel'}
          >
            {Messages.cancel()}
          </ButtonWidget>
        </span>
        <span>
          <ButtonWidget
            type="submit"
            buttonType={ButtonType.Primary}
            testId={props.testId + '-save'}
            disabled={props.disabled !== undefined ? props.disabled : !props.formik.isValid}
            onClick={() => props.handleSubmit ? props.handleSubmit() : props.formik.submitForm()}
          >
            {Messages.saveChanges()}
          </ButtonWidget>
        </span>
      </td>
    </tr>
  );
}